import React from 'react'

export const EditableContext = React.createContext(null)

export const EditableProvider = ({ value = {}, children }) => {
  return (
    <EditableContext.Provider value={value}>
      {children}
    </EditableContext.Provider>
  )
}

export const useEditable = () => {
  const context = React.useContext(EditableContext)

  if (context === null) {
    throw new Error(
      'Attempted to call useEditable outside the Editable component.'
    )
  }

  return context
}
